import { ButtonHTMLAttributes, memo } from 'react';
import './Button.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
    size?: 'sm' | 'md' | 'lg';
    fullWidth?: boolean;
    isLoading?: boolean;
}

/**
 * Button Component
 * Reusable button with multiple variants and sizes
 */
export const Button = memo<ButtonProps>(
    ({
        children,
        variant = 'primary',
        size = 'md',
        fullWidth = false,
        isLoading = false,
        disabled,
        className = '',
        ...props
    }) => {
        const classes = [
            'btn',
            `btn--${variant}`,
            `btn--${size}`,
            fullWidth && 'btn--full',
            isLoading && 'btn--loading',
            className,
        ]
            .filter(Boolean)
            .join(' ');

        return (
            <button className={classes} disabled={disabled || isLoading} {...props}>
                {isLoading ? <span className="btn__spinner" /> : null}
                <span className={isLoading ? 'btn__text--hidden' : ''}>{children}</span>
            </button>
        );
    }
);

Button.displayName = 'Button';
